// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2FzLv","form":"styles_form__wL0bf"};